<template>
    <div class="kcc-new-center-out">
        <div class="top-bar">
            <div class="top-bar-left">
                <svg-icon icon-name="home-top" size="32"></svg-icon>
                <div class="top-text">{{this.$t('KPMG_INSIGHTS')}}</div>
            </div>
            <button class="top-bar-right cus-btn" @click="drawerClick">
                <svg-icon icon-name="client-user" size="20"></svg-icon>
                <div class="top-text">{{this.$t('WHAT_DOES_CLIENT_DASHBORD_SEE')}}</div>
                <i class="el-icon-right"></i>
            </button>
        </div>
        <div class="kcc-new-center">

            <div class="__top">
                <div class="news-container">
                    <div class="flex item-center mb-10">
                        <img width="26" src="@/assets/img/logo_kcc_news.png">
                        <div class="font-bold ml-10 font-title">{{ $t('newsMgt.title1') }}</div>
                    </div>
                    <div class="flex" style="height: calc(100% - 30px);">
                        <div class="h-full __left">
                            <el-carousel arrow="never" :autoplay="true">
                                <el-carousel-item v-for="item in kccNewsBanner" :key="item.id">
                                    <div class="flex h-full pointer" :title="item.newsTitle" style="border-radius: 6px; overflow: hidden;" @click="toOuterLink(item.linkUrl)">
                                        <img v-if="item.newsImage" :src='`data:image/png;base64,${item.newsImage}`'  
                                            class="news-pic" :alt="item.newsTitle" >
                                        <div class="desc-pop">
                                            <p class="font-bold mb-10" style="font-size: 14px;">{{ item.newsTitle }}</p>
                                            <p class="news-desc" style="font-size: 14px;">{{ item.newsDesc }}</p>
                                            <a class="new-link __a" >
                                                <img class="mr-5" style="position: relative; top: 1px;" src="@/assets/img/icon-link.svg">
                                                <span>{{ item.linkText }}</span>
                                            </a>
                                        </div>
                                    </div>
                                    <!-- <a class="new-link" @click="toOuterLink(item.linkUrl)">
                                        <img class="mr-5" src="@/assets/img/icon-link.svg">
                                        <span class="link-title">{{ item.linkText }}</span>
                                    </a> -->
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                        <div v-if="kccNewsRight.length" class="h-full __right">
                            <div class="__right__inner">
                                <div class="__item flex pointer" v-for="item in kccNewsRight"  @click="toOuterLink(item.linkUrl)">
                                    <div class="img-box">
                                        <img style="" :src='`data:image/png;base64,${item.newsImage}`' :alt="item.newsTitle">
                                    </div>
                                    <div class="info-box">
                                        <p class="news-title font-bold mb-5">{{ item.newsTitle }}</p>
                                        <p class="news-desc">{{ item.newsDesc }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="onboard-container">
                    <div class="mid-left">
                        <div class="flex item-center mb-10">
                            <img class="" src="@/assets/img/icon-onboard.svg">
                            <div class="font-bold ml-10 font-title">{{ $t('newsMgt.title2') }}</div>
                        </div>
                        <div class="flex flex-inner" style="width: 100%;">
                            <div class="mid-left__left" style="width: 50%; padding-right: 15px;">
                                <div class="border-normal flex p-15 w-50%" style="min-height: 25%;">
                                    <img class="mr-10 video-fill" src="@/assets/img/icon-video-fill.svg">
                                    <div>
                                        <div>
                                            {{ $t('newsMgt.videoList.introduction') }}
                                        </div>
                                        <a class="onboard-link" @click="toOuterLink(video_En)">{{
                                            $t('newsMgt.videoList.en') }}</a>
                                        <a class="onboard-link" @click="toOuterLink(video_Cn)">{{
                                            $t('newsMgt.videoList.cn') }}</a>
                                        <a class="onboard-link" @click="toOuterLink(video_yueyu)">{{
                                            $t('newsMgt.videoList.yueyu') }}</a>
                                    </div>
                                </div>
                                <div class="border-normal flex p-15 flex-1 pointer" style="min-height: 25%;" @click="toOuterLink(video_title)">
                                    <img class="mr-10 video-fill" src="@/assets/img/icon-video-fill.svg">
                                    <div>
                                        <div>{{ $t('newsMgt.videoList.newlyLaunched') }}</div>
                                    </div>
                                </div>
                                <div class="learning-course pointer" style="min-height: 25%;" @click="toOuterLink(eLearningUrl)">
                                    <img class="mr-10" src="@/assets/img/icon-elearning.svg">
                                    {{ $t('newsMgt.learningCourse') }}
                                </div>
                            </div>
                            <div class="mid-left__right" style="width: 50%;">
                                <div v-for="child in materialsList" :key="child.id" class="w-full h-full pointer"
                                    @click="toOuterLink(child.linkUrl)">
                                    <img v-if="child.materialImage"
                                        :src='`data:image/png;base64,${child.materialImage}`'
                                        class="w-full material-pic">
                                    <p class="material-title" >{{ child.materialTitle }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mid-right">
                        <div class="training-container flex">
                            <div class="document-container">
                                <div class="flex item-center mb-5">
                                    <img class="" src="@/assets/img/icon-communicate.svg">
                                    <div class="font-bold ml-10 font-title">{{ $t('newsMgt.title3') }}</div>
                                </div>
                                <div class="document-list">
                                    <div v-for="item in documentList" :key="item.id"
                                        @click="toOuterLink(item.hyperlink)" class="doc-title">
                                        <svg-icon :iconName="renderFileType(item.docName)" size="16"
                                            class="mr-10"></svg-icon>
                                        {{ item.docName }}
                                    </div>

                                </div>
                            </div>
                            <div class="code-view">
                                <img :src="$i18n.locale === 'en' ? qrCodeEn : qrCodeCn" class="qr-code">
                                <div class="font-bold">
                                    {{ $t('newsMgt.title4') }}
                                </div>
                                <p>{{ $t('newsMgt.scanTips') }}</p>
                                <img src="@/assets/img/icon-overview-phone.png" class="code-handle">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="__bottom">
                <div class="flex item-center mb-10">
                    <img style="width: 20px" src="@/assets/img/Icon-OAK.png">
                    <div class="font-bold ml-10 font-title">{{$t('newsMgt.kdcNews')}}</div>
                </div>
                <el-carousel arrow="always" :autoplay="true">
                    <el-carousel-item v-for="(item,index) in kdcNews" :key="index">
                        <div class="flex h-full" style="gap: 10px">
                            <div v-for="child in item" :key="child.id" class="bottom__item pointer" @click="toOuterLink(child.linkUrl)" :title="child.newsTitle">
                                <img v-if="child.newsImage" :src='`data:image/png;base64,${child.newsImage}`' class="h-full material-pic">
                                <p class="material-title" :title="child.newsTitle">{{ child.newsTitle }}</p>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
    </div>
</template>
<script>
import API from '@/api'
import SvgIcon from "@/components/svgIcon/index";

export default {
    name: 'ContentLeft',
    components: { SvgIcon },
    data() {
        return {
            video_En: 'https://kpmgcn.mediaspace.sg.kaltura.com/media/0_w9rnj0g7',
            video_Cn: 'https://kpmgcn.mediaspace.sg.kaltura.com/media/0_ijojn7oa',
            video_yueyu: 'https://kpmgcn.mediaspace.sg.kaltura.com/media/0_flmep6c5',
            video_title: 'https://kpmgcn.mediaspace.sg.kaltura.com/media/t/0_mef2c9wg',
            eLearningUrl: 'https://kcc.uat.cn.kworld.kpmg.com/%E6%93%8D%E4%BD%9C%E6%8C%87%E5%BC%95-%20%E8%AE%BE%E7%BD%AE%E5%92%8C%E6%90%AD%E5%BB%BA%E6%82%A8%E9%A1%B9%E7%9B%AE%E7%9A%84KCC%E7%AB%99%E7%82%B9%E6%A1%86%E6%9E%B6.pdf',
            kccNewsList: [],
            kccNewsBanner: [],
            kccNewsRight: [],
            materialsList: [],
            kdcNews: [],
            documentList: [],
            qrCodeCn: require(`@/assets/img/qrCodeCn.png`),
            qrCodeEn: require(`@/assets/img/qrCodeEn.png`)
        }
    },
    mounted() {
        this.getNews()
        this.queryKccUsefulDocuments()
        this.queryKccTrainingMaterials()
        this.queryKdcNews()
    },
    methods: {
        drawerClick() {
            this.$emit('drawerClick')
        },
        toOuterLink(url) {
            if (!url) return
            window.open(url)
        },
        async getNews() {
            const { code, data } = await API.system.queryKccNews('KCC')
            if (code === '1') {
                this.kccNewsList = data;
                // kccNewsBanner: [],
                // kccNewsRight: [],
                // 右侧放4个, 超过5个时才有右侧，
                this.kccNewsRight = data.length >= 5 ? data.slice(3) : data
                this.kccNewsBanner = data.length >= 5 ? data.slice(0,3) : []
            }
        },
        async queryKccUsefulDocuments() {
            const { code, data } = await API.system.queryKccUsefulDocuments()
            if (code === '1') {
                this.documentList = data;
            }
        },
        async queryKccTrainingMaterials() {
            const { code, data } = await API.system.queryKccTrainingMaterials()
            if (code === '1') {
                const result = []
                // for (let i = 0; i < data.length; i += 3) {
                //     result.push(data.slice(i, i + 3))
                // }
                this.materialsList = data.slice(0, 1);
            }
        },
        // kdcNews
        async queryKdcNews() {
            const { code, data } = await API.system.queryKccNews('KDC')
            if (code === '1') {
                const result = []
                for (let i = 0; i < data.length; i += 4) {
                    result.push(data.slice(i, i + 4))
                }
                this.kdcNews = result;
            }
        },
        renderFileType(name) {
            const fileType = name.substring(name.lastIndexOf(".") + 1).toLowerCase()
            const iconName = fileType ? 'file-' + fileType : 'file-pdf'
            return iconName
        }
    }
}
</script>
<style scoped>
.top-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px
}
.top-bar-left, .top-bar-right {
    display: flex;
    align-items: center;
    font-weight: 700
}
.top-bar-left {
    font-size: 20px;
}
.top-bar-left .top-text {
    margin-left: 8px
}
.top-bar-right {
    font-size: 14px;
    color: #fff;
    background: #1E49E2;
    border-radius: 4px;
    cursor: pointer;
    padding: 6px 8px;
}
.top-bar-right .top-text {
    margin:0 4px;
    font-size: 15px;
}
.mb-5 {
    margin-bottom: 5px;
}

.font-bold {
    font-weight: bold;
}

.font-title {
    font-size: 15PX;
}

::v-deep .news-container .el-carousel__button {
    display: block;
    opacity: .4;
    background-color: #0338f7;
    border: none;
    outline: 0;
    padding: 0;
    margin: 0;
    cursor: pointer;
    transition: .3s;
    width: 10px;
    height: 10px;
    border-radius: 100%;
}

::v-deep .news-container .el-carousel__indicator.is-active button {
    opacity: 1;
}


::v-deep .news-container .el-carousel {
    height: 100%;
}

::v-deep .news-container .el-carousel__container {
    height: 100%;
}

::v-deep .news-container .el-carousel__indicators--horizontal {
    right: 0;
    left: auto;
    transform: none;
}

.kcc-new-center-out {
    width: 60%;
    height: 100%;
    /* background: #fff; */
    padding: 14PX;
    padding-bottom: 0;
}

.cus-btn {
    display: flex;
    align-items: center;
    padding-left: 0.1rem;
    padding-right: 0.1rem;
    padding-top: -0.5rem;
    padding-bottom: -0.5rem;
    border: none;
    background-image: linear-gradient(to right, var(--tw-gradient-stops));
    color: #fff;
    font-weight: 800;
    font-size: -0.875rem;
    line-height: -0.25rem;
    border-radius: 9999px;
    --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
    --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
    transition-duration: 500ms;
    margin-left: 1rem;
    animation: heartBeat 2.4s infinite;
}

@keyframes heartBeat {
    0% { transform: scale(1); }
    25% { transform: scale(1.07); }
    50% { transform: scale(1); }
    75% { transform: scale(1.07); }
  }



.kcc-new-center {
    width: 100%;
    height: 100%;
    /* overflow-y: auto; */
}

.kcc-new-center::-webkit-scrollbar {
  width: 10PX !important;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 10PX !important;
}

.__top {
    height: 64%;
    /* min-height: 500PX; */
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.__bottom {
    margin-top: 15px;
    background-color: #fff;
    border-radius: 12px;
    height: 265px;
    height: 30%;
    max-height: 280PX;
    padding: 15PX;
    margin-bottom: 16PX;
}

.bottom__item {
    flex: 1;
    max-width: 24.1%;
}

::v-deep .__bottom .el-carousel {
    height: calc(100% - 30px);
}

.news-container {
    height: calc(100% - 230px);
    /* min-height: 250PX; */
    /* height: 400px; */
    /* max-height: 350PX; */
    padding: 14PX 15PX 0 15PX;
    background: #fff;
    border-radius: 12px 12px 0 0;
}

.news-container .__left {
    flex: 1;
    border-radius: 6px;
}

.news-container .__right {
    width: 320PX;
    padding-left: 20px;
    overflow-y: overlay;
}

.news-container .__right::-webkit-scrollbar {
  width: 6PX !important;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 6PX !important;
}

.news-container .__right::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 11PX;
  background-color: transparent !important;
  transition: background-color 0.3s;
}

.news-container .__right:hover::-webkit-scrollbar-thumb {
  background-color: hsla(220, 4%, 58%, 0.3) !important;
}

.news-container .__right .__right__inner {
    width: 100%;
    height: 100%;
    background-color: #F3F3F3;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
}
.news-container .__right .__right__inner .__item {
    background-color: #fff;
    border-radius: 3px;
    flex: 1;
}

.news-container .__right .__right__inner .__item .img-box {
    width: 56PX;
    margin-right: 10px;
}

.img-box img {
    width: 56PX;
    height: 100%;
    border-radius: 6px;
    object-fit: cover;
}

.news-container .__right .__right__inner .__item .info-box {
    height: 100%;
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.news-pic {
    /* width: 220px;
    height: 140px; */
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.desc-pop {
    width: 50%;
    position: absolute;
    bottom: 20px;
    left: 20px;
    border-radius: 6px;
    padding: 12px;
    background-color: rgba(255, 255, 255, .9);

    
}

.desc-pop p {
    color: #000;
    display: -webkit-box !important;
    -webkit-box-orient: vertical !important;
    -webkit-line-clamp: 3 !important; /* 限制显示3行 */
    overflow: hidden !important;
    white-space: unset !important;
}
.desc-pop a {
    color: #00338D;
}

.material-pic {
    height: calc(100% - 35px);
    border-radius: 6px;
    overflow: hidden;
    width: 100%;
    object-fit: cover;
}

.new-link {
    color: #00338D;
    font-size: 12px;
    cursor: pointer;
    margin-top: 10px;
    display: flex;
    align-items: center;
    max-width: 50%;
}

.new-link.__a {
    max-width: 100%;
}

.new-link.__a span {
    overflow: hidden; /* 超出部分隐藏 */
    white-space: nowrap; /* 文本不换行 */
    text-overflow: ellipsis;
}

.new-link.__a span {
    font-size: 12PX;
}

.news-desc {
    color: #7d7d87;
    overflow: auto;
    max-height: 90px;
}

.link-title, .news-desc, .news-title {
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    white-space: nowrap;
}

::v-deep .__bottom .el-carousel__container {
    height: 100%;
}

::v-deep .__bottom .el-carousel__arrow--right {
    top: 40%;
    right: -10px;
    overflow: hidden;
}

::v-deep .__bottom .el-carousel__arrow--left {
    top: 40%;
    left: -10px;
    overflow: hidden;
}

.onboard-container {
    display: flex;
    /* height: 50%;
    height: 230PX;
    min-height: 200PX; */
    height: 260px;
    max-height: 320PX;
    margin: 0;
    background: #ffffff;
    padding: 15px;
    padding-bottom: 15PX;
    /* overflow: auto; */
    /* box-shadow: 1px -2px 12px rgba(215, 215, 215, 0.5) */
}

.flex-inner {
    height: calc(100% - 30px);
}

.mid-left__left {
    display: flex;
    flex-direction: column;
    gap: 16px;
}
.mid-left__left > div {
    flex: 1;
}

.onboard-container .mid-left {
    width: 50%;
}

.onboard-container .mid-right {
    width: 50%;
}

.video-fill {
    width: 20PX;
    height: 20PX;
}

.video-list-item {
    width: 50%;
}

.onboard-link {
    text-decoration: underline;
    color: #2f56e4;
    cursor: pointer;
    margin-right: 10px
}

.p-15 {
    padding: 0 10px;
    border-radius: 4px;
    /* justify-content: center; */
    align-items: center;
}

.pointer {
    cursor: pointer;
}

.bottom-splitLine {
    border-bottom: 1px dashed #e8e8e8;
    padding-bottom: 10px;
}

.material-title {
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    white-space: nowrap;
    margin-top: 8px;
}

.w-32 {
    width: 32%;
}

.w-50 {
    width: 50%;
}

.w-32:nth-child(2n) {
    margin: 0 2%;
}

.learning-course {
    background: #00338D;
    padding: 5px 15px;
    border-radius: 4px;
    color: white;
    display: flex;
    align-items: center;
    font-weight: bold;
    height: 40PX;
    flex: unset !important;
}

.training-container {
    height: 100%;
}

.document-container {
    /* margin-right: 10px; */
    background-color: white;
    padding: 0 15px 0px 15px;
    width: calc(100% - 160px);
}

.document-list {
    height: calc(100% - 30px);
    overflow: auto;
}

.document-list::-webkit-scrollbar {
  width: 10PX !important;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 10PX !important;
}

.doc-title {
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    white-space: nowrap;
    color: #7d7d87;
    margin: 10px 0;
    cursor: pointer;
}

.doc-title:hover {
    color: #1e49e2;
}

.code-view {
    width: 160px;
    background-size: contain;
    color: white;
    height: 100%;
    text-align: center;
    background: #678aeb;
    text-align: center;
    border-radius: 6px;
    padding: 15px;
    overflow: hidden;
}

.qr-code {
    width: 85%;
    height: 50%;
}

.code-handle {
    width: 86px;
    margin-right: -100px;
}
</style>